import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["keyname", "name"];
import { Block } from 'react-login-page';
import { jsx as _jsx } from "react/jsx-runtime";
export var Logo = props => {
  var {
      keyname = 'logo',
      name
    } = props,
    elmProps = _objectWithoutPropertiesLoose(props, _excluded);
  if (!elmProps.children) {
    elmProps.children = '⚛️';
  }
  var nameBase = name || keyname;
  return /*#__PURE__*/_jsx(Block, _extends({}, elmProps, {
    keyname: nameBase,
    className: "login-page8-logo " + (elmProps.className || '')
  }));
};
Logo.displayName = 'Login.Logo';